/* eslint-disable indent */
import {RMASummary} from 'extensions/rma/components/x-rma-summary';
import {defineCustomElement} from 'extensions/ui-utils';
import stylesheet from './x-rma-review-summary.scss?as=stylesheet';

export class RMAReviewSummary extends RMASummary {
	static get styles () {
		return [
			...super.styles,
			stylesheet
		];
	}

	constructor () {
		super();

		/**
		 * @type {boolean}
		 */
		this.disableButton = true;
	}
};

defineCustomElement('x-rma-review-summary', RMAReviewSummary);
